// libraries
import clsx from 'clsx'

// components
import RoundedBox from '/react4xp/components/RoundedBox'

// types
export interface StudyCardProps {
    className?: string
    href?: string
    title?: string
    subject?: string
    points?: number
    pointsText?: string
    pointsAbbreviation?: string
    studyCode?: string
}

// css
import './index.scss'

export default function StudyCard({
    className,
    href,
    title,
    subject,
    points,
    pointsText,
    pointsAbbreviation,
    studyCode
}: StudyCardProps) {
    return (
        <div
            className={clsx(
                'study-card-component',
                className
            )}
        >
            <RoundedBox
                bgColor='white'
                className='study-card-component__box'
            >

                {href && ( <a href={href} className='study-card-component__link' /> )}

                <div className='study-card-component__content'>
                    {title && (
                        <h3 className={clsx(
                            'lead-paragraph',
                            href && 'hover-underline'
                        )}>
                            {title}
                        </h3>
                    )}

                    {studyCode && (
                        <p className='study-card-component__study-code body-small'>
                            {studyCode}
                        </p>
                    )}
                </div>

                <div className='study-card-component__bottom'>

                    {subject && (
                        <p className='study-card-component__subject body-small'>
                            {subject}
                        </p>
                    )}

                    {(points || pointsText) && (
                        <p className='study-card-component__points body-small'>
                            {pointsText ? pointsText : `${points} ${pointsAbbreviation}`}
                        </p>
                    )}

                </div>

            </RoundedBox>
        </div>
    )
}